import { useTranslation } from 'react-i18next'

export const useLegalLinks = (): {
  termsAndConditions: { label: string; url: string }
  privacy: { label: string; url: string }
} => {
  const { t } = useTranslation()

  const termsAndConditions = {
    label: t('legal.termsAndConditions.labelText'),
    url: t('legal.termsAndConditions.labelLink'),
  }

  const privacy = {
    label: t('legal.privacy.labelText'),
    url: t('legal.privacy.labelLink'),
  }

  return {
    termsAndConditions,
    privacy,
  }
}
